/**
 * A press, a move or a start that reached no computer SAYS so (DEC-138: never a
 * silent dead control; audit 2026-11-03 A-4). Only plain buttons did: a grid
 * cell, a piano key, a fader, an XY pad, an LFO, a sequencer or a macro at a
 * computer that refused or was gone flashed and did nothing, with nothing on
 * screen. Counted per COMPUTER (an XY move is two sends to each), and once per
 * 3 s per control, so a fader ridden at a dead computer is one toast, not one
 * per value. Quiet while PANIC is locked: its banner already says nothing sends.
 */

import { plainFireReason, type FireResult } from '../opbridge/dispatch.ts';
import { panicLatched } from '../performance/panicLatch.ts';
import { pushToast } from './toast.ts';

const THROTTLE_MS = 3000;
const lastAt = new Map<string, number>();

export function reportSend(controlId: string, who: string, results: readonly FireResult[]): void {
  if (results.length === 0 || panicLatched()) return;
  const failed = results.filter((r) => r.kind !== 'ok');
  if (failed.length === 0) return;
  const now = Date.now();
  if (now - (lastAt.get(controlId) ?? 0) < THROTTLE_MS) return;
  lastAt.set(controlId, now);
  const all = new Set(results.map((r) => r.target));
  const bad = new Set(failed.map((r) => r.target));
  const partial = bad.size < all.size;
  pushToast(partial ? 'warn' : 'error',
    `${who}: ${partial ? `${all.size - bad.size} of ${all.size} computers got it; ` : 'not sent - '}${plainFireReason(failed[0]!)}.`, 4000);
}

/** The control's own name, or what it is. */
export function controlName(item: { name?: string | undefined }, fallback: string): string {
  return item.name?.trim() || fallback;
}
